import React from 'react';
import Carousel, {
  autoplayPlugin,
  slidesToShowPlugin,
} from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import brand01 from '../img/brands/01_ms.png';
import brand02 from '../img/brands/02_jnj.png';
import brand03 from '../img/brands/03_mercedes.png';
import brand04 from '../img/brands/04_rakuten.png';
import brand05 from '../img/brands/05_gsk.png';
import brand06 from '../img/brands/06_dell.png';
import brand07 from '../img/brands/07_dentsu.png';
import brand08 from '../img/brands/08_pru.png';
import brand09 from '../img/brands/09_toyota.png';
import brand10 from '../img/brands/10_citybank.png';
import brand11 from '../img/brands/11_wpp.png';

const brands = [
  {
    key: '1',
    img: brand01,
  },
  {
    key: '2',
    img: brand02,
  },
  {
    key: '3',
    img: brand03,
  },
  {
    key: '4',
    img: brand04,
  },
  {
    key: '5',
    img: brand05,
  },
  {
    key: '6',
    img: brand06,
  },
  {
    key: '7',
    img: brand07,
  },
  {
    key: '8',
    img: brand08,
  },
  {
    key: '9',
    img: brand09,
  },
  {
    key: '10',
    img: brand10,
  },
  {
    key: '11',
    img: brand11,
  },
];

function TrustedAndUse() {
  return (
    <>
      <section className='trusted d-flex-col align-items-center justify-content-center gap-2 text-center'>
        <div className='title'>
          <h2 className='text-title'>Trusted & Used by</h2>
          <div className='line'></div>
        </div>
        <Carousel
          plugins={[
            'centered',
            'infinite',
            'arrows',
            {
              resolve: slidesToShowPlugin,

              options: {
                numberOfSlides: 5,
              },
            },
            {
              resolve: autoplayPlugin,

              options: {
                interval: 2000,
              },
            },
          ]}
          animationSpeed={1000}
        >
          {brands.map((brand) => (
            <img key={brand.key} src={brand.img} alt='brand' />
          ))}
        </Carousel>
      </section>
    </>
  );
}

export default TrustedAndUse;
